import * as React from 'react';
import { app, authentication } from '@microsoft/teams-js';

export default class RedirectSucess extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        app.initialize()
            .then(() => {
                authentication.notifySuccess();
            })
    }
    render() {
        return (<>Redirecting...</>);        
    }
}